import React, { useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import RemoteTable from '../RemoteTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

export default function Cluster() {
  const [step, setStep] = useState('INPUT');
  const [showModal, setShowModal] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [atualizando, setAtualizando] = useState(false);
  const [showModalAtualizarParceiro, setShowModalAtualizarParceiro] = useState(false);
  const [cpfParceiro, setCpfParceiro] = useState('');
  const [atualizandoParceiro, setAtualizandoParceiro] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [statusImg, setStatusImg] = useState('Procurar...');
  const [data, setData] = useState({
    id: null,
    nome: '',
    img: '',
    ordem: 0,
    clubProPintor: false,
    enviandoNf: false,
    resgateItens: false,
    cursosOne: false,
    cursosAll: false,
    acheSeuPintor: false,
    fotoPerfil: false,
    fotoVideoTrabalhos: false,
    parcelaPintura: false,
    valorPonto: '',
    triggerLimite: '',
    tipo: '',
  });

  const resetForm = () => {
    setStep('INPUT');
    setStatusImg('Procurar...');
    const inputFile = document.getElementById('arquivo-cluster');
    if (inputFile) {
      inputFile.value = null;
    }
    setData({
      id: null,
      nome: '',
      img: '',
      ordem: 0,
      clubProPintor: false,
      enviandoNf: false,
      resgateItens: false,
      cursosOne: false,
      cursosAll: false,
      acheSeuPintor: false,
      fotoPerfil: false,
      fotoVideoTrabalhos: false,
      parcelaPintura: false,
      valorPonto: '',
      triggerLimite: '',
      tipo: '',
    });
  };

  const salvarCluster = async (e) => {
    e.preventDefault();
    setEnviando(true);

    try {
      const inputFile = document.getElementById('arquivo-cluster');
      const arquivo = inputFile?.files?.[0];

      let clusterId = data.id;

      if (!clusterId) {
        const resCreate = await api.post(`/api/cluster`, data);
        if (resCreate && resCreate.status >= 200 && resCreate.status < 300) {
          clusterId = resCreate.data.id;
          if (arquivo) {
            const formData = new FormData();
            formData.append('arquivo', arquivo);
            formData.append('idCluster', clusterId);

            try {
              await api.post('/api/upload/cluster_foto', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            } catch (uploadErr) {
              const mensagemErro = uploadErr.response?.data?.erro || 'Erro ao fazer upload da imagem.';
              toast.error(mensagemErro, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 5000,
              });
            }
          }
          toast.success('Cluster criado com sucesso.', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
          });
          setShowModal(false);
          resetForm();
          setRefreshKey((k) => k + 1);
        }
      } else {
        if (arquivo) {
          const formData = new FormData();
          formData.append('arquivo', arquivo);
          formData.append('idCluster', clusterId);

          try {
            const uploadRes = await api.post('/api/upload/cluster_foto', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });

            if (uploadRes && uploadRes.status === 200) {
              data.img = uploadRes.data.img;
            }
          } catch (uploadErr) {
            const mensagemErro = uploadErr.response?.data?.erro || 'Erro ao fazer upload da imagem.';
            toast.error(mensagemErro, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 5000,
            });
            setEnviando(false);
            return;
          }
        }

        const res = await api.put(`/api/cluster/${clusterId}`, data);
        
        if (res && res.status >= 200 && res.status < 300) {
          toast.success('Cluster atualizado com sucesso.', {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
          });
          setShowModal(false);
          resetForm();
          setRefreshKey((k) => k + 1);
        }
      }
    } catch (err) {
      const mensagemErro = err.response?.data?.erro || 'Erro ao salvar o Cluster.';
      toast.error(mensagemErro, {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 5000,
      });
    } finally {
      setEnviando(false);
    }
  };

  const atualizarClusters = async () => {
    setAtualizando(true);
    toast.info('Iniciando atualização de clusters...', {
      position: toast.POSITION.BOTTOM_CENTER,
    });

    try {
      await api.get('/api/job');
      toast.success('Clusters atualizados com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      window.location.reload();
    } catch (err) {
      toast.error('Erro ao atualizar clusters.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setAtualizando(false);
    }
  };

  const atualizarClusterParceiro = async (e) => {
    e.preventDefault();

    if (!cpfParceiro || !cpfParceiro.trim()) {
      toast.error('Por favor, informe o CPF do parceiro.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setAtualizandoParceiro(true);
    const cpfLimpo = cpfParceiro.replace(/\D/g, '');

    try {
      await api.post('/api/job/parceiro', { cpf: cpfLimpo });
      toast.success('Cluster do parceiro atualizado com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setShowModalAtualizarParceiro(false);
      setCpfParceiro('');
    } catch (err) {
      const mensagemErro = err.response?.data?.erro || 'Erro ao atualizar cluster do parceiro.';
      toast.error(mensagemErro, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setAtualizandoParceiro(false);
    }
  };

  const columns = [
    { dataField: 'id', text: 'ID', sort: true, hidden: true },
    { dataField: 'nome', text: 'Nome', sort: true },
    { dataField: 'tipo', text: 'Tipo', sort: true },
    { dataField: 'ordem', text: 'Ordem', sort: true },
    {
      dataField: 'edit',
      text: 'Alterar',
      formatter: (cell, row) => (
        <button
          className="bg-transparent border-0"
          type="button"
          onClick={() => {
            setData({ ...row });
            setStatusImg(row.img ? 'Imagem existente' : 'Procurar...');
            setShowModal(true);
          }}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  const handleInput = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  const booleanField = (field, label) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input
        type="checkbox"
        id={field}
        style={{ margin: 0, height: '25px' }}
        checked={data[field]}
        onChange={(e) => handleInput(field, e.target.checked)}
      />
      <label htmlFor={field} style={{ margin: 0, marginLeft: '6px' }}>
        {label}
      </label>
    </div>
  );

  return (
    <Container fluid>
      <div>
        <h4 className="pt-3 pb-3 f-black">Cluster</h4>
        <hr className="hr-loja mt-0 mb-4" />
      </div>

      <div className="d-flex justify-content-end mb-4" style={{ gap: '10px' }}>
        <button
          className="btn-primario"
          onClick={atualizarClusters}
          disabled={atualizando}
        >
          {atualizando ? 'ATUALIZANDO...' : 'ATUALIZAR CLUSTERS'}
        </button>
        <button
          className="btn-primario"
          onClick={() => {
            setCpfParceiro('');
            setShowModalAtualizarParceiro(true);
          }}
        >
          ATUALIZAR CLUSTER DO USUARIO
        </button>
        <button
          className="btn-primario"
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
        >
          NOVO CLUSTER
        </button>
      </div>

      <RemoteTable
        key={refreshKey}
        dataId="id"
        url="/api/cluster"
        colunas={columns}
        ordenacaoInicial={{ campo: 'ordem', direcao: 'asc' }}
        search={false}
      />

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          resetForm();
        }}
        centered
      >
        <Modal.Header closeButton>
          {data.id ? 'Editar Cluster' : 'Criar Cluster'}
        </Modal.Header>
        <Modal.Body>
          {step === 'INPUT' && (
            <form className="form" onSubmit={(e) => e.preventDefault()}>
              <label>Nome</label>
              <input
                type="text"
                className="form-control mb-2"
                value={data.nome}
                onChange={(e) => handleInput('nome', e.target.value)}
              />

              <label>Imagem</label>
              <input
                type="file"
                id="arquivo-cluster"
                name="arquivo"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={(e) => {
                  if (e.target.files && e.target.files.length > 0) {
                    setStatusImg(e.target.files[0].name);
                  } else {
                    setStatusImg('Procurar...');
                  }
                }}
              />
              <input
                id="botao-cluster-img"
                type="button"
                className="form-control mb-2"
                value={statusImg}
                onClick={() => {
                  document.getElementById('arquivo-cluster').click();
                }}
              />

              <label>Ordem</label>
              <input
                type="number"
                className="form-control mb-2"
                value={data.ordem}
                onChange={(e) => handleInput('ordem', Number(e.target.value))}
              />

              <label>Tipo</label>
              <input
                type="text"
                className="form-control mb-2"
                value={data.tipo}
                onChange={(e) => handleInput('tipo', e.target.value)}
              />

              <label>Fator de pontuação</label>
              <input
                type="number"
                step="0.1"
                className="form-control mb-2"
                value={data.valorPonto}
                onChange={(e) => handleInput('valorPonto', e.target.value)}
              />

              <label>Trigger limite</label>
              <input
                type="number"
                step="0.1"
                className="form-control mb-2"
                value={data.triggerLimite}
                onChange={(e) => handleInput('triggerLimite', e.target.value)}
              />

              <div className="mt-3">
                {booleanField('clubProPintor', 'Inscrito no Clube Pro Pintor')}
                {booleanField('enviandoNf', 'Enviou NF')}
                {booleanField('resgateItens', 'Resgate de itens (nos últimos 270 dias)')}
                {booleanField('cursosOne', 'Fez 1 Curso')}
                {booleanField('cursosAll', 'Fez todos os Cursos')}
                {booleanField('acheSeuPintor', 'Inscrito no Ache Seu Pintor')}
                {booleanField('fotoPerfil', 'Colocou Foto Perfil')}
                {booleanField(
                  'fotoVideoTrabalhos',
                  'Colocou Foto/Vídeo de Trabalhos'
                )}
                {booleanField('parcelaPintura', 'Parcela Pintura')}
              </div>

              <div className="mt-3 d-flex justify-content-end">
                <button
                  className="btn-secundario px-2"
                  onClick={() => {
                    setShowModal(false);
                    resetForm();
                  }}
                >
                  Cancelar
                </button>
                <button
                  className="btn-primario ml-2"
                  onClick={salvarCluster}
                  disabled={enviando}
                >
                  {enviando ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showModalAtualizarParceiro}
        onHide={() => {
          setShowModalAtualizarParceiro(false);
          setCpfParceiro('');
        }}
        centered
      >
        <Modal.Header closeButton>
          Atualizar Cluster do Usuário
        </Modal.Header>
        <Modal.Body>
          <form className="form" onSubmit={atualizarClusterParceiro}>
            <label>CPF do Parceiro</label>
            <input
              type="text"
              className="form-control mb-2"
              value={cpfParceiro}
              onChange={(e) => setCpfParceiro(e.target.value)}
              placeholder="Digite o CPF (apenas números)"
              maxLength={14}
            />
            <div className="mt-3 d-flex justify-content-end">
              <button
                type="button"
                className="btn-secundario px-2"
                onClick={() => {
                  setShowModalAtualizarParceiro(false);
                  setCpfParceiro('');
                }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn-primario ml-2"
                disabled={atualizandoParceiro}
              >
                {atualizandoParceiro ? 'Atualizando...' : 'Atualizar'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
